// Progress tracker for the Dayforce + NetSuite pipelines.
// Eliminates the duplicate progress UI that lived twice in Extraction.jsx.

const STATUS_COLORS = {
  succeeded: { border: '#28a745', bg: '#d4edda', fg: '#155724', label: 'Succeeded' },
  failed:    { border: '#dc3545', bg: '#f8d7da', fg: '#721c24', label: 'Failed' },
  running:   { border: '#FF6600', bg: '#fff3cd', fg: '#856404', label: 'Running' },
};

const STEP_DOT_BG = {
  succeeded: '#155724',
  running:   '#FF6600',
  failed:    '#721c24',
  pending:   '#999',
};

function StepRow({ step, idx }) {
  const dotChar =
    step.status === 'succeeded' ? '✓' :
    step.status === 'failed'    ? '✗' : idx + 1;
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '6px 0', fontSize: 14 }}>
      <span
        style={{
          width: 22, height: 22, borderRadius: '50%',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          marginRight: 10, fontSize: 13, fontWeight: 700, color: '#fff',
          background: STEP_DOT_BG[step.status] || STEP_DOT_BG.pending,
        }}
      >
        {dotChar}
      </span>
      <span style={{ flex: 1, color: step.status === 'pending' ? '#999' : '#333' }}>
        <strong>Step {idx + 1}:</strong> {step.name}
      </span>
      <span
        style={{
          fontSize: 12, color: '#666', maxWidth: 350, textAlign: 'right',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}
      >
        {step.status === 'running'   && 'In progress...'}
        {step.status === 'succeeded' && (step.detail || 'Done')}
        {step.status === 'failed'    && (step.detail || 'Failed')}
      </span>
    </div>
  );
}

export function PipelineProgress({ status, title }) {
  if (!status) return null;
  const colors = STATUS_COLORS[status.status] || STATUS_COLORS.running;

  return (
    <div
      style={{
        margin: '16px 0', padding: '16px 20px',
        background: '#f8f9fa', borderRadius: 8,
        border: '1px solid #dee2e6',
        borderLeft: `4px solid ${colors.border}`,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <strong style={{ color: '#002159' }}>{title}</strong>
        <span
          style={{
            padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
            background: colors.bg, color: colors.fg,
          }}
        >
          {colors.label}
        </span>
      </div>
      {status.start_date && (
        <div style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
          Range: {status.start_date} to {status.end_date}
        </div>
      )}
      {status.steps?.map((step, i) => (
        <StepRow key={i} step={step} idx={i} />
      ))}
      {status.status === 'running' && (
        <div style={{ fontSize: 12, color: '#666', marginTop: 8, fontStyle: 'italic' }}>
          Polling every 5 seconds... Do not close this page.
        </div>
      )}
    </div>
  );
}
